<template>
  <div :class="['panel-container', sidebarStore.isOpen ? 'panel-container--sidebar-open' : 'panel-container--sidebar-close' ]">
    <div class="panel">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useSidebarStore} from "@/store/sidebar/sidebar";

const sidebarStore = useSidebarStore();
</script>

<style lang="scss" scoped>
.panel-container--sidebar-open {
  left: 252px;
}

.panel-container--sidebar-close {
  left: 98px;
}

.panel-container {
  height: 57px;

  position: fixed;
  top: 72px;


  right: 12px;
  min-width: 743px;

  background-color: $page-background-color;

  z-index: 1000;
}

.panel {
  height: 100%;

  display: flex;
  align-items: center;

  background-color: white;
  border-radius: 8px;
}
</style>
